$(document).ready(function () {

//search_ticket
    $('#serie').on('input', function () {
        $(this).val($(this).val().toUpperCase());
    });

    $('#folio').on('input', function () {
        $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });

    $(document).on('click', '#search_ticket', function (event) {
        event.preventDefault();

        let serie = $("#serie").val();
        let folio = $("#folio").val();

        loading_small('div_result');

        if ($.trim(serie) === "") {
            Swal.fire('Advertencia', 'Ingrese una serie a buscar', 'error');
            $("#div_result").html("");
        } else if ($.trim(folio) === "") {
            Swal.fire('Advertencia', 'Ingrese un folio a buscar', 'error');
            $("#div_result").html("");
        } else {

            let url = window.location.origin + '/get-ticket'
            let formData = new FormData();

            formData.append('sucursal_id', $("#sucursal_id").val());
            formData.append('serie', serie);
            formData.append('folio', folio);

            $.ajax({
                data: formData,
                url: url,
                //type: 'PUT',
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {

                    if (response['success'] === "false") {
                        Swal.fire('Advertencia', response['msg'], 'error');
                        $("#div_result").html("");
                        return false;
                    }

                    $("#div_result").html(response);
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                    $('#table_resutl_tickets').dataTable({
                        "language": {
                            "url": window.location.origin + "/json/Spanish.json"
                        },
                    });

                })
                .fail(function (jqXHR, textStatus) {
                    ResponseFail(jqXHR);
                });
        }

    });

    $(document).on("click", ".delete-mov-ticket", function (e) {
        e.preventDefault();
        let table = $("#table_resutl_tickets").DataTable()
        let row = table.row($(this).parents('tr'));
        var motivo = "";

        Swal.fire({
            title: "Desea eliminar el " + row.data()[5] + " de $" + row.data()[4],
            text: "¿Eliminar?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Sí, Eliminar",
            cancelButtonText: "Cancelar",
        }).then(resultado => {
            if (resultado.value) {
                Swal.fire({
                    title: 'Motivo de eliminación',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off',
                        required: 'true'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: "Cancelar",
                    showLoaderOnConfirm: true,
                    preConfirm: (mensaje) => {
                        //cuando viene vacio
                        const mensajeTrimmed = mensaje.trim();
                        if (mensajeTrimmed === '' || mensajeTrimmed.length < 15) {
                            Swal.showValidationMessage('El motivo debe tener al menos 15 caracteres.');
                            return false;
                        }
                        motivo = mensaje;
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        togglePreloader();
                        let url = window.location.origin + '/delete-transaction-server'
                        let formData = new FormData();

                        //cuando haya timepo enviar el objeto compelto pra recuperar todos los datos consultados y asi no campo por campo por si lo mueven iordaz
                        formData.append('sucursal_id', $("#sucursal_id").val());
                        formData.append('serie', $("#serie").val());
                        formData.append('folio', $("#folio").val());
                        formData.append('tipo', ((row.data()[5] === "Incremento") ? "increase" : "decrease"));
                        formData.append('motivo', motivo);
                        formData.append('user_id_delete', $("#user_id_delete").val());


                        $.ajax({
                            data: formData,
                            url: url,
                            type: 'POST',
                            contentType: false,
                            processData: false,
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                if (response.success != 'true') {
                                    Swal.fire('Advertencia', response.msg, 'error');
                                    return false;
                                }
                                Swal.fire('Eliminado', response.msg, 'success');
                                row.remove().draw();
                            })
                            .fail(function (jqXHR, textStatus) {
                                ResponseFail(jqXHR);
                            })
                            .always(function () {
                                togglePreloader();
                            });
                    }
                });
            }
        });
    });

    $(document).on("click", ".delete-item", function (e) {
        e.preventDefault();
        $(".serie_transaction").val($(this).attr("data-serie"));
        $(".folio_transaction").val($(this).attr("data-folio"));
        $(".sucursal_transaction").val($(this).attr("data-sucursal"));
        $("#confirmacion-eliminar-transaccion").modal('show');
    });

    $(document).on("click", ".confirmacion-eliminar", function (e) {
        e.preventDefault();

        var motivo = $("#motivo_modal").val();

        if (motivo.length < 15) {
            alert("El campo debe tener al menos 15 caracteres.");
            $("#motivo_modal").focus();
            return false;
        }

        togglePreloader();

        const sucursal_id = $(".sucursal_transaction").val();
        const serie = $(".serie_transaction").val();
        const folio = $(".folio_transaction").val();

        let url = window.location.origin + '/delete-transaction-detail'
        let formData = new FormData();

        formData.append('sucursal_id', sucursal_id);
        formData.append('serie', serie);
        formData.append('folio', folio);
        formData.append('user_id_delete', $("#user_id_delete").val());
        formData.append('motivo', motivo);

        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                $("#confirmacion-eliminar-transaccion").modal('hide');

                if (response.success != 'true') {
                    Swal.fire('Advertencia', response.msg, 'error');
                    return "false";
                }
                $('.res-ticket').remove();
                $(".serie").val('');
                $(".folio").val('');

                Swal.fire('Eliminado', response.msg, 'success');
                window.location.reload()
            })
            .fail(function (jqXHR, textStatus) {
                ResponseFail(jqXHR);
            })
            .always(function () {
                togglePreloader();
            });

    });


});

